export default function toTitleCase(str: string): string {
    if (!str) {
        return '';
    }

    const title = str.replace(/([A-Z])/g, ' $1');

    return title.charAt(0).toUpperCase() + title.slice(1);
}
